import React, { useState } from 'react';
import Modal from '../components/Modal';
import { formatActivationCodeForDisplay } from '../confirm/requisition-details/ActivationNumber';

/**
 * Allows a client to change the Orderable Item associated to a collection pack.
 */
const RepurposeCollectionPack = ({ gbfSharedKitsMap, orderableItem, repurposeDetails, handleRepurpose }) => {
	const [isModalDisplayed, setIsModalDisplayed] = useState(false);
	let itemsWithSameKit = gbfSharedKitsMap?.[orderableItem?.gbfName];

	if (!itemsWithSameKit?.length) {
		return null;
	}

	const onSelection = (omsOrderableItemId) => {
		// If the selection matches the current orderableItem then we don't need to do anything
		if (omsOrderableItemId === orderableItem?.id) {
			return;
		}

		handleRepurpose(omsOrderableItemId);
	};

	return (
		<>
			<button
				className="btn btn-link btn-unstyled"
				style={{
					paddingLeft: '5px',
					paddingBottom: '5px',
					display: 'block',
					fontSize: '85%',
					marginTop: '-10px'
				}}
				onClick={(event) => {
					event.preventDefault();
					setIsModalDisplayed(true);
				}}
			>
				I would like to use this pack for a different test.
			</button>
			{isModalDisplayed && (
				<RepurposePackModal
					items={itemsWithSameKit}
					currentOrderablItemId={orderableItem?.id}
					activationCode={repurposeDetails?.activationCode}
					onSelection={onSelection}
					onClose={() => setIsModalDisplayed(false)}
				/>
			)}
		</>
	);
};

const RepurposePackModal = ({ items, currentOrderablItemId, activationCode, onSelection, onClose }) => {
	const modalProps = {
		displayProps: {
			modalHeader: {
				className: 'modal-header text-center',
				style: { borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }
			},
			modalContent: { style: { borderRadius: '20px' } }, // Round corners
			modalBody: { className: 'modal-body text-center' } // Center text
		},
		doConfirm: null,
		modalHidden: onClose,
		title: 'Choose Your Test'
	};

	const formattedActivationCode = formatActivationCodeForDisplay(activationCode);

	return (
		<Modal {...modalProps}>
			<p>
				You may use this pack (activation number <strong>{formattedActivationCode}</strong>) for any of the
				following tests. Please select the desired panel below.
			</p>
			<div className="list-group">
				{items.map((item) => {
					let buttonClass = 'list-group-item';
					if (currentOrderablItemId === item.id) {
						buttonClass += ' list-group-item-info';
					}
					return (
						<button
							className={buttonClass}
							key={item.id}
							onClick={(event) => {
								event.preventDefault();
								onClose();
								onSelection(item.id);
							}}
						>
							{item.name}
						</button>
					);
				})}
			</div>
		</Modal>
	);
};

export default RepurposeCollectionPack;
